module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./src/frontend-lib/~/axios/index.js
// module id = k/xo
// module chunks = 0